import axios from 'axios';
import { Template } from '../types/template';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const getTemplates = async (): Promise<Template[]> => {
  try {
    const response = await axios.get(`${API_URL}/templates`);
    return response.data;
  } catch (error) {
    console.error('Error fetching templates:', error);
    throw error;
  }
};

export const getTemplate = async (id: string): Promise<Template> => {
  try {
    const response = await axios.get(`${API_URL}/templates/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching template with ID ${id}:`, error);
    throw error;
  }
};

export const getTemplatesByCategory = async (category: string): Promise<Template[]> => {
  try {
    const response = await axios.get(`${API_URL}/templates/category/${category}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching templates by category ${category}:`, error);
    throw error;
  }
};

export const getUserTemplates = async (): Promise<Template[]> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Authentication required');
    }
    
    const response = await axios.get(`${API_URL}/templates/user/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user templates:', error);
    throw error;
  }
};

export const createTemplate = async (templateData: Partial<Template>): Promise<Template> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Authentication required');
    }
    
    const response = await axios.post(`${API_URL}/templates`, templateData, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      transformRequest: [(data) => data],
    });
    return response.data;
  } catch (error) {
    console.error('Error creating template:', error);
    throw error;
  }
};

export const updateTemplate = async (id: string, templateData: Partial<Template>): Promise<Template> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Authentication required');
    }
    
    const response = await axios.put(`${API_URL}/templates/${id}`, templateData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating template with ID ${id}:`, error);
    throw error;
  }
};

export const deleteTemplate = async (id: string): Promise<void> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Authentication required');
    }
    
    await axios.delete(`${API_URL}/templates/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (error) {
    console.error(`Error deleting template with ID ${id}:`, error);
    throw error;
  }
}; 